import _regeneratorRuntime from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _objectSpread from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _defineProperty from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "F:\\a4\\_work\\9\\s\\Server\\Presentation\\DispatchPortal\\DispatchPortal\\ClientApp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { LogLevel } from "./ILogger";
import { NullLogger } from "./Loggers"; // Version token that will be replaced by the prepack command

/** The version of the SignalR client. */

export var VERSION = "6.0.1";
/** @private */

export var Arg =
/*#__PURE__*/
function () {
  function Arg() {
    _classCallCheck(this, Arg);
  }

  _createClass(Arg, null, [{
    key: "isRequired",
    value: function isRequired(val, name) {
      if (val === null || val === undefined) {
        throw new Error("The '".concat(name, "' argument is required."));
      }
    }
  }, {
    key: "isNotEmpty",
    value: function isNotEmpty(val, name) {
      if (!val || val.match(/^\s*$/)) {
        throw new Error("The '".concat(name, "' argument should not be empty."));
      }
    }
  }, {
    key: "isIn",
    value: function isIn(val, values, name) {
      // TypeScript enums have keys for **both** the name and the value of each enum member on the type itself.
      if (!(val in values)) {
        throw new Error("Unknown ".concat(name, " value: ").concat(val, "."));
      }
    }
  }]);

  return Arg;
}();
/** @private */

export var Platform =
/*#__PURE__*/
function () {
  function Platform() {
    _classCallCheck(this, Platform);
  }

  _createClass(Platform, null, [{
    key: "isBrowser",
    get: function get() {
      return typeof window === "object";
    }
  }, {
    key: "isWebWorker",
    get: function get() {
      return typeof self === "object" && "importScripts" in self;
    }
  }, {
    key: "isNode",
    get: function get() {
      return !this.isBrowser && !this.isWebWorker;
    }
  }]);

  return Platform;
}();
/** @private */

export function getDataDetail(data, includeContent) {
  var detail = "";

  if (isArrayBuffer(data)) {
    detail = "Binary data of length ".concat(data.byteLength);

    if (includeContent) {
      detail += ". Content: '".concat(formatArrayBuffer(data), "'");
    }
  } else if (typeof data === "string") {
    detail = "String data of length ".concat(data.length);

    if (includeContent) {
      detail += ". Content: '".concat(data, "'");
    }
  }

  return detail;
}
/** @private */

export function formatArrayBuffer(data) {
  var view = new Uint8Array(data); // Uint8Array.map only supports returning another Uint8Array?

  var str = "";
  view.forEach(function (num) {
    var pad = num < 16 ? "0" : "";
    str += "0x".concat(pad).concat(num.toString(16), " ");
  }); // Trim of trailing space.

  return str.substr(0, str.length - 1);
} // Also in signalr-protocol-msgpack/Utils.ts

/** @private */

export function isArrayBuffer(val) {
  return val && typeof ArrayBuffer !== "undefined" && (val instanceof ArrayBuffer || // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
  val.constructor && val.constructor.name === "ArrayBuffer");
}
/** @private */

export function sendMessage(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
  return _sendMessage.apply(this, arguments);
}
/** @private */

function _sendMessage() {
  _sendMessage = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(logger, transportName, httpClient, url, accessTokenFactory, content, options) {
    var headers, token, _getUserAgentHeader, _getUserAgentHeader2, name, value, responseType, response;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            headers = {};

            if (!accessTokenFactory) {
              _context.next = 6;
              break;
            }

            _context.next = 4;
            return accessTokenFactory();

          case 4:
            token = _context.sent;

            if (token) {
              headers = _defineProperty({}, "Authorization", "Bearer ".concat(token));
            }

          case 6:
            _getUserAgentHeader = getUserAgentHeader(), _getUserAgentHeader2 = _slicedToArray(_getUserAgentHeader, 2), name = _getUserAgentHeader2[0], value = _getUserAgentHeader2[1];
            headers[name] = value;
            logger.log(LogLevel.Trace, "(".concat(transportName, " transport) sending data. ").concat(getDataDetail(content, options.logMessageContent), "."));
            responseType = isArrayBuffer(content) ? "arraybuffer" : "text";
            _context.next = 12;
            return httpClient.post(url, {
              content: content,
              headers: _objectSpread({}, headers, options.headers),
              responseType: responseType,
              timeout: options.timeout,
              withCredentials: options.withCredentials
            });

          case 12:
            response = _context.sent;
            logger.log(LogLevel.Trace, "(".concat(transportName, " transport) request complete. Response status: ").concat(response.statusCode, "."));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _sendMessage.apply(this, arguments);
}

export function createLogger(logger) {
  if (logger === undefined) {
    return new ConsoleLogger(LogLevel.Information);
  }

  if (logger === null) {
    return NullLogger.instance;
  }

  if (logger.log !== undefined) {
    return logger;
  }

  return new ConsoleLogger(logger);
}
/** @private */

export var SubjectSubscription =
/*#__PURE__*/
function () {
  function SubjectSubscription(subject, observer) {
    _classCallCheck(this, SubjectSubscription);

    this._subject = subject;
    this._observer = observer;
  }

  _createClass(SubjectSubscription, [{
    key: "dispose",
    value: function dispose() {
      var index = this._subject.observers.indexOf(this._observer);

      if (index > -1) {
        this._subject.observers.splice(index, 1);
      }

      if (this._subject.observers.length === 0 && this._subject.cancelCallback) {
        this._subject.cancelCallback().catch(function (_) {});
      }
    }
  }]);

  return SubjectSubscription;
}();
/** @private */

export var ConsoleLogger =
/*#__PURE__*/
function () {
  function ConsoleLogger(minimumLogLevel) {
    _classCallCheck(this, ConsoleLogger);

    this._minLevel = minimumLogLevel;
    this.out = console;
  }

  _createClass(ConsoleLogger, [{
    key: "log",
    value: function log(logLevel, message) {
      if (logLevel >= this._minLevel) {
        var msg = "[".concat(new Date().toISOString(), "] ").concat(LogLevel[logLevel], ": ").concat(message);

        switch (logLevel) {
          case LogLevel.Critical:
          case LogLevel.Error:
            this.out.error(msg);
            break;

          case LogLevel.Warning:
            this.out.warn(msg);
            break;

          case LogLevel.Information:
            this.out.info(msg);
            break;

          default:
            // console.debug only goes to attached debuggers in Node, so we use console.log for Trace and Debug
            this.out.log(msg);
            break;
        }
      }
    }
  }]);

  return ConsoleLogger;
}();
/** @private */

export function getUserAgentHeader() {
  var userAgentHeaderName = "X-SignalR-User-Agent";

  if (Platform.isNode) {
    userAgentHeaderName = "User-Agent";
  }

  return [userAgentHeaderName, constructUserAgent(VERSION, getOsName(), getRuntime(), getRuntimeVersion())];
}
/** @private */

export function constructUserAgent(version, os, runtime, runtimeVersion) {
  // Microsoft SignalR/[Version] ([Detailed Version]; [Operating System]; [Runtime]; [Runtime Version])
  var userAgent = "Microsoft SignalR/";
  var majorAndMinor = version.split(".");
  userAgent += "".concat(majorAndMinor[0], ".").concat(majorAndMinor[1]);
  userAgent += " (".concat(version, "; ");

  if (os && os !== "") {
    userAgent += "".concat(os, "; ");
  } else {
    userAgent += "Unknown OS; ";
  }

  userAgent += "".concat(runtime);

  if (runtimeVersion) {
    userAgent += "; ".concat(runtimeVersion);
  } else {
    userAgent += "; Unknown Runtime Version";
  }

  userAgent += ")";
  return userAgent;
} // eslint-disable-next-line spaced-comment

/*#__PURE__*/

function getOsName() {
  if (Platform.isNode) {
    switch (process.platform) {
      case "win32":
        return "Windows NT";

      case "darwin":
        return "macOS";

      case "linux":
        return "Linux";

      default:
        return process.platform;
    }
  } else {
    return "";
  }
} // eslint-disable-next-line spaced-comment

/*#__PURE__*/


function getRuntimeVersion() {
  if (Platform.isNode) {
    return process.versions.node;
  }

  return undefined;
}

function getRuntime() {
  if (Platform.isNode) {
    return "NodeJS";
  } else {
    return "Browser";
  }
}
/** @private */


export function getErrorString(e) {
  if (e.stack) {
    return e.stack;
  } else if (e.message) {
    return e.message;
  }

  return "".concat(e);
}
/** @private */

export function getGlobalThis() {
  // globalThis is semi-new and not available in Node until v12
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }

  if (typeof self !== "undefined") {
    return self;
  }

  if (typeof window !== "undefined") {
    return window;
  }

  if (typeof global !== "undefined") {
    return global;
  }

  throw new Error("could not find global");
}